import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useThemeComponents } from '../../../../themes';
import { getButtonVariantsForModal } from '../../../../themes/default/Modal';

const useNoInventoryModal = () => {
    const { theme, Modal, Button } = useThemeComponents();
    const { t } = useTranslation('configuratorJourney');
    const [visible, setVisible] = useState(false);
    const navigate = useNavigate();

    const actions = {
        open: () => setVisible(true),
        close: () => {
            setVisible(false);
            navigate('..');
        },
    };

    const variants = getButtonVariantsForModal(theme);

    return {
        ...actions,
        render: () => (
            <Modal
                footer={
                    <Button htmlType="button" onClick={actions.close} type={variants.cancel}>
                        {t('configuratorJourney:noInventoryModal.okButton')}
                    </Button>
                }
                onCancel={actions.close}
                onOk={actions.close}
                open={visible}
                title={t('configuratorJourney:noInventoryModal.title')}
                destroyOnClose
            >
                {t('configuratorJourney:noInventoryModal.content')}
            </Modal>
        ),
    };
};

export default useNoInventoryModal;
